import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '@/shared/components';

export const PagesListPage: React.FC = () => {
  const pages = [
    {
      id: 'index',
      title: 'Главная страница',
      description: 'Фото коллектива, лента фотографий клиники и виджет отзывов',
      icon: 'fas fa-home',
      href: '/pages/index'
    },
    {
      id: 'customer-information',
      title: 'Информация для потребителей',
      description: 'Редактирование содержимого страницы /customer-information',
      icon: 'fas fa-info-circle',
      href: '/pages/customer-information'
    }
  ];

  return (
    <Layout title="Настройки страниц">
      <div className="space-y-6">
        <div>
          <p className="text-base-content/60 mt-1">
            Управление контентом и настройками страниц сайта
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {pages.map((page) => (
            <Link
              key={page.id}
              to={page.href}
              className="card card-bordered bg-base-100 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="card-body">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                    <i className={`${page.icon} text-primary`}></i>
                  </div>
                  <div>
                    <h3 className="card-title text-base">{page.title}</h3>
                  </div>
                </div>
                <p className="text-sm text-base-content/60 mt-2">
                  {page.description}
                </p>
                <div className="card-actions justify-end mt-4">
                  <span className="text-primary text-sm font-medium">
                    Настроить <i className="fas fa-arrow-right ml-1"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
};
